module.exports = __webpack_public_path__ + "static/2-e356e5639ceb12f274233906029befb1.jpg";